import moment from 'moment';

export const normalizeDay = date => moment(date).startOf('day');

export const getToday = () => moment().startOf('day');

export const getEarliestDate = dates => moment(Math.min(...dates.map(date => normalizeDay(date).valueOf())));

export const getLatestDate = dates => moment(Math.max(...dates.map(date => normalizeDay(date).valueOf())));

export const normalizeDateForServer = date => {
    if (!date) {
        return undefined;
    }

    return new Date(date).toISOString();
}

export const getDatesArray = (start, end) => {
    const days = [];
    let day = start;

    while (day <= end) {
        days.push(day.toDate());
        day = day.clone().add(1, 'd');
    }

    return days;
}
